import { render, staticRenderFns } from "./CardBlocksTab.vue?vue&type=template&id=3d237948&"
import script from "./CardBlocksTab.vue?vue&type=script&lang=js&"
export * from "./CardBlocksTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports